import { useRef as f } from "react";
function r(e) {
  const t = f(e);
  return t.current = e, t;
}
export {
  r as u
};
//# sourceMappingURL=refs-CANlwHhW.js.map
